<template>
  <div class="main_address_dark" :class="{ 'dark-mode': isDarkMode }">
    <link rel="stylesheet" :href="themeLink" id="theme-stylesheet" />
  <div class="main_address">
    <div class="address-page">
      <div class="left_address" @click="handleGoBack">
        <img src="../../images/left_arrowd.png" alt="Back Button" class="back-button" />
        <span class="text">Back</span>
      </div>
      <div class="rectangle_add_images">
        <img src="../../images/rectangle.png" alt="rectangles" />
      </div>
      <div class="content">
        <h2>Scan QR</h2>
      </div>
    </div>
    <div class="inverter_image">
      <img src="../../images/inverter.png" alt="" />
      <div class="arrow_image">
        <img src="../../images/arrow.png" alt="" />
      </div>
    </div>
    <div class="label">
      <p>Label can be seen on the panel <br />Scan to view Inverter Details.</p>
    </div>
    <div class="button-container">
      <input type="file" accept="image/*" @change="uploadImage" class="file-input" id="file-input" />
      <label for="file-input" class="upload-button">Upload from Gallery</label>
    </div>
    <div style="margin-top: 10px;">
      <button class="show_me" @click="showPopup = true">Show me what to post</button>
    </div>
    <div v-if="showPopup" class="popup">
      <div class="popup-content">
        <img src="../../images/scanner_image.jpg" alt="Example" class="popup-image" />
        <p class="popup-text">Label can be seen on the panel <br> Scan to view Inverter details.</p>
        <img src="../../images/cross.svg" alt="Close" class="close-popup" @click="showPopup = false" />
      </div>
    </div>
    <div v-if="inverterData" class="inverter-details">
      <h3>Inverter Details</h3>
      <p><strong>Capacity:</strong> {{ inverterData.capacity }}</p>
      <p><strong>Model:</strong> {{ inverterData.model }}</p>
      <p><strong>Brand:</strong> {{ inverterData.brand }}</p>
    </div>
  </div>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { useToast } from 'vue-toastification';
import axios from 'axios';

export default {
  setup() {
    const toast = useToast();
        const toastOptions = {
      timeout: 1000, 
    };
    return { toast , toastOptions };
  },
  data() {
    return {
      showPopup: false,
      inverterData: null,
      isDarkMode: false,

    };
  },
  computed: {
    themeLink() {
      return this.isDarkMode ? "/dark-theme.css" : "";
    },
  },
  async mounted() {
    this.inverterData = null; 
    const savedDarkMode = localStorage.getItem("darkMode");
    if (savedDarkMode === "true") {
      this.isDarkMode = true;
    }
    this.applyDarkMode();
  },
  
  methods: {
    applyDarkMode() {
      const themeLinkElement = document.getElementById("theme-stylesheet");
      if (themeLinkElement) {
        themeLinkElement.href = this.themeLink;
      } else {
        console.error("Theme stylesheet link element not found");
      }
      document.body.classList.toggle("dark-mode", this.isDarkMode);
    },
    handleGoBack() {
      this.$router.go(-1);
    },
    ...mapActions(['saveInverterData']),
    async uploadImage(event) {
      const file = event.target.files[0];
      if (file) {
        const formData = new FormData();
        formData.append('image', file);
        console.log('File selected:', file);

        try {
          // const response = await this.fetchInverterData(formData);
          // const { model, capacity, brand } = response;
          // this.inverterData = { model, capacity, brand };
          // this.inverterData = response;
          this.inverterData ={
              capacity: 8,
              model: "SUN-5K-G03",
              brand: "DEYE",
            }
          this.saveInverterData(this.inverterData);
          // console.log('Inverter Data:', this.inverterData);

          this.toast.success('Inverter details fetched successfully.', this.toastOptions);
          setTimeout(() => {
            this.$router.push('/scanqr');
          }, 2000);
        } catch (error) {
          console.error('Error uploading image:', error);
          this.toast.error('Error retrieving inverter data.', this.toastOptions);
        }
      }
    },
    async fetchInverterData(formData) {
      try {
        const response = await axios.post('https://api.voltbrew.energy/api/upload-label', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        return response.data;
      } catch (error) {
        console.error('Error uploading image:', error);
        throw error;
      }
    }
  }
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700&display=swap");

body {
  font-family: "Montserrat", sans-serif;
}
.left_address{
  display:flex;
  align-items:center;
  gap:5px;
  color:#fff;
  font-family: 'Montserrat';
font-size: 14px;
}
.back-button{
  height: 18px;
}
.address-page {
  max-width: 100%;
  height: 30vh;
  margin: auto;
  border-bottom-left-radius: 35px;
  border-bottom-right-radius: 35px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  background: linear-gradient(to right, #050011, #120b41);
  overflow-x: hidden;
  position: relative;
  padding: 20px;
}
.rectangle_add_images {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
}
.rectangle_add_images img {
  height: 200px;
  width: 336px;
}
.content {
  position: absolute;
  top: 30%;
  left: 28px;
  color: white;
  text-align: left;
}
h2 {
  font-family: "Montserrat";
  font-weight: 700;
  font-size: 30px;
  line-height: 1.2;
  margin-top: 22px;
}
.show {
  font-size: 12px;
  font-family: "Montserrat";
}
.inverter_image {
  position: relative;
  margin-top: 50px;
  left: -5px;
}
.inverter_image img {
  object-fit: contain;
}
.arrow_image {
  position: absolute;
  top: 60%;
  left: 20%;
}
.label {
  padding-left: 5px;
  font-size: 12px;
  font-family: "Montserrat";
}
.button-container {
  display: flex;
  justify-content: center;
  width: 100%;
}

.upload-button {
  background-color: #453a94;
  border: none;
  color: white;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 12px;
  font-family: "Montserrat";
  width: 65%;
  margin-top: 45px;
  text-align: center;
}

.show_me {
  background-color: #F4F4F4;
  border: none;
  color: #453a94;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 12px;
  font-family: "Montserrat";
  width: 65%;
  margin: auto;
}

.upload-button:hover {
  background-color: #7a6ed6;
}

.popup {
  position: fixed;
  top: 5%;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}

.popup-content {
  background: white;
  padding: 40px 22px;
  border-radius: 10px;
  position: relative;
  text-align: center;
  max-width: 90%;
}

.popup-image {
  width: 100%;
  max-width: 300px;
  height: auto;
  margin-bottom: 20px;
}

.popup-text {
  font-family: "Montserrat";
  font-size: 14px;
}

.close-popup {
  position: absolute;
  top: 15px;
  right: 10px;
  cursor: pointer;
}

.file-input {
  display: none;
}

.inverter-details {
  margin: 20px;
  padding: 20px;
  background-color: #f4f4f4;
  border-radius: 10px;
  text-align: left;
}

.inverter-details h3 {
  font-size: 18px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 10px;
}

.inverter-details p {
  font-size: 14px;
  margin: 10px 0;
}

@media (min-width: 568px) {
  .arrow_image {
    left: 30%;
  }
}

@media (min-width: 768px) {
  .arrow_image {
    left: 36%;
  }
}

@media (min-width: 992px) {
  .arrow_image {
    left: 39%;
  }
}
</style>
